var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmptyView',{attrs:{"name":_vm.t('spreed', 'You do not have permissions to access this conversation.'),"description":_vm.t('spreed', 'Join a different conversation or start a new one.')},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('Octagon')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }